module.exports = __webpack_public_path__ + "media/smw_power-up_appears.1f4184e6.ogg";